import styled, { createGlobalStyle } from 'styled-components';

export const PopoverReset = createGlobalStyle`
  .no-padding-popover {
    .ant-popover-inner-content {
      min-width: 300px;
      padding: 0 !important;
    }
  }
<<<<<<< HEAD
=======
  .ModalDefaultStyle {
    /* 公告弹出框宽度 */
    max-width: 900px !important;
    .ant-modal-content {
      overflow: auto;
    }
    .ant-modal-body {
      padding: 0;
    }
  }
>>>>>>> bc7c5b3953d703f35151ce716b5af74692e80bd2
  .notice-scroll::-webkit-scrollbar {
    width: 6px;
    overflow: hidden;
  }
  .notice-scroll::-webkit-scrollbar-track {
    background: transparent !important;  /* 轨道颜色 */
  }
`;

export const NoticeItem = styled.div`
  padding: 12px;
  border-bottom: 1px solid #f0f0f0;
  cursor: pointer;
  transition: background-color 0.2s;
  border-radius: 8px;

  &:last-of-type { border-bottom: none; }
  &:hover {
    /* background-color: #fafafa; */
  }

  /* 当前在右侧展示的公告 */
  ${({ $current }) =>
    $current &&
    `
    background-color: rgba(22, 119, 255, 0.06);
  `}
`;

/* 包裹整个 noticeContent 的最外层容器 */
export const NoticeListWrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  max-width: 300px;
`;

/* 单条 notice 中：上半行（标签 + 日期） */
export const NoticeMeta = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
`;

/* 标签左侧容器（让“new”红点与 Tag 横向排列） */
export const TagArea = styled.div`
  display: flex;
  padding-bottom: 4px;
`;

/* 日期文字 */
export const NoticeDate = styled.div`
  color: rgba(0, 0, 0, 0.65);
`;

/* 标题文字 */
export const NoticeTitle = styled.div`
  text-align: left;
  color: rgba(0, 0, 0, 0.85);
  white-space: nowrap;      /* 禁止换行 */
  overflow: hidden;         /* 隐藏溢出内容 */
  text-overflow: ellipsis;  /* 溢出部分用 … 表示 */

  ${({ $active }) =>
    $active &&
    `
    color: rgba(22, 119, 255, 1);
  `}
`;
/* 无数据占位 */
export const EmptyText = styled.div``;

export const NoticeTitleBar = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 40px;
`;

export const NoticeTitleLeft = styled.span``;

export const NoticeMoreBtn = styled.span`
  color: #1890ff;
  cursor: pointer;
`;

/* Modal 外层容器 */
export const ModalBody = styled.div`
  display: flex;
  gap: 16px;
  height: auto;
  max-height: 45vh;
  min-height: 20vh;
  justify-content: space-between;
`;

/* 左侧公告列表 */
export const NoticeListPane = styled.div`
  overflow-y: auto;
  overflow-x: hidden;
  margin-right: -10px;
  min-width: 220px;
`;

/* 分割线 */
export const Divider = styled.div`
  width: 1px;
  background-color: rgba(0, 0, 0, 0.1);
`;

/* 右侧内容区 */
export const ContentPane = styled.div`
  width: 100%;
  overflow-y: auto;
`;